module.exports = __webpack_public_path__ + "static/media/reading-green.914672da.svg";